import { createTheme } from '@mui/material/styles'
import { blue, grey, lightBlue, orange, red, yellow } from '@mui/material/colors';
import { action, computed, observable, makeObservable, reaction } from "mobx";
import StoreParaSingleton from "./StoreParaSingleton";

const THEME_LIGHT = createTheme({
    typography: {
        fontFamily: 'Liberation Sans, Helvetica, Arial, sans-serif',
        body2: {
            lineHeight: '1'
        },
        h6: {
            fontSize: '18px'
        },
    },
    palette: {
        primary: {
            light: '#b71c1c',
            main: lightBlue[900],
            dark: '#bbdefb',
            contrastText: '#fff',
        },
        secondary: {
            light: '#f05545',
            main: red[900],
            dark: '#7f0000',
            contrastText: '#fff',
        }
    },

    // overrides: {
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    padding: 0,
                    color: 'inherit'
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'inherit'
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 1200
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: 'white',
                        backgroundColor: '#01579b',
                        transition: 'all 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        fontStyle: 'italic',
                        fontWeight: '600'
                    },
                    textColorPrimary: 'white !important'
                },
                // selected: { backgroundColor: 'white', color: 'white' },
                textColorPrimary: 'white !important'
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    "&.Mui-focused": {
                        color: '#01579b',
                        fontWeight: 'bold'
                    }
                },
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    marginTop: '5px'
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#01579b',
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '10pt',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '500px'
                }
            }
        },
        MuiFab: {
            styleOverrides: {
                secondary: {
                    color: 'white !important',
                    backgroundColor: '#b71c1c !important'
                },
                sizeSmall: {
                    height: '36px'
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    zIndex: 100
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                '.MuiInputBase-sizeSmall': {
                    padding: '2px'
                },
                '.titulo': {
                    color: '#01579B'
                },
                '.item-minuta:hover': {
                    backgroundColor: '#e1f5fe',
                },
                '.item-processo:hover': {
                    backgroundColor: '#e1f5fe',
                },
                '.sumario-acoes-content:hover': {
                    color: '#FFF',
                },
                '.botao-distribuicao-manual>button:hover': {
                    color: 'black !important'
                },
                '.items-sumario>div>button:hover': {
                    color: 'black !important'
                },
                '.botao-visto': {
                    color: blue[700]
                },
                '.botao-visto:hover': {
                    color: blue[900]
                },
                '.botao-assinatura': {
                    color: blue[700]
                },
                '.botao-assinatura:hover': {
                    color: blue[900]
                },
                '.MuiButton-containedPrimary:hover': {
                    backgroundColor: 'rgb(25, 128, 230) !important'
                },
                '.numero-paginacao': {
                    color: '#0d47a1'
                }
            }
        },
    }

});

const THEME_DARK = createTheme({
    typography: {
        fontFamily: 'Liberation Sans, Helvetica, Arial, sans-serif',
        body2: {
            lineHeight: '1'
        },
        h6: {
            fontSize: '18px'
        },
    },
    palette: {
        background: {
            default: '#2e2e2e'
        },
        primary: {
            main: lightBlue[800]
        },
        secondary: {
            main: yellow[800],
        }
    },
    // overrides: {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    backgroundColor: '#2e2e2e'
                },
                body: {
                    color: 'white'
                },
                div: {
                    borderTopColor: '#000000',
                    borderRightColor: '#000000',
                    borderBottomColor: '#000000',
                    borderLeftColor: '#000000'
                },
                '.Mui-disabled': {
                    color: 'rgba(256, 256, 256, 0.22) !important'
                },
                '.MuiRadio-colorPrimary.Mui-checked': {
                    color: 'rgba(71, 155, 223,0.85) !important'
                },
                '.MuiFab-root:hover': {
                    color: 'rgba(256,256,256,1)'
                },
                '.MuiButton-root:hover': {
                    color: 'rgba(256,256,256,1)'
                },
                '.MuiAutocomplete-popupIndicator': { // TODO
                    color: 'rgba(256, 256, 256, 0.87)'
                },
                '.MuiAutocomplete-clearIndicator': { // TODO
                    color: 'rgba(256, 256, 256, 0.87)'
                },
                '.item-minuta:hover': {
                    backgroundColor: '#010101',
                    color: '#FFF'
                },
                '.item-processo:hover': {
                    backgroundColor: '#010101',
                    color: '#FFF'
                },
                '.sumario-acoes-content>div>button:hover': {
                    color: '#FFF',
                },
                '.botao-distribuicao-manual>button:hover': {
                    color: 'white !important'
                },
                '.items-sumario>div>button:hover': {
                    color: 'white !important'
                },
                '.botao-visto': {
                    color: grey[500]
                },
                '.botao-visto:hover': {
                    color: 'white'
                },
                '.botao-assinatura': {
                    color: grey[500]
                },
                '.botao-assinatura:hover': {
                    color: 'white'
                },
                '.titulo': {
                    color: lightBlue[300]
                },
                '.titulo-tabela': {
                    color: lightBlue[300]
                },
                '.numero-paginacao': {
                    color: lightBlue[300]
                },
                '.item-backdrop': {
                    backgroundColor: '#2e2e2e !important'
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    "&.Mui-focused": {
                        color: 'white',
                        fontWeight: 'bold'
                    }
                },
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '10pt',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '500px'
                }
            }
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    color: 'rgba(256,256,256,0.75)'
                },
                secondary: {
                    color: 'white !important',
                    backgroundColor: yellow[900] + ' !important'
                },
                sizeSmall: {
                    height: '36px'
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: 'white',
                        backgroundColor: '#01579b',
                        transition: 'all 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                    }
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: lightBlue[700],
                    color: 'white'
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    zIndex: 100,
                    // backgroundColor: '#2e2e2e'
                }
            }
        },
        MuiPaper: {

            styleOverrides: {
                root: {
                    backgroundColor: '#2e2e2e',
                    color: '#ffffff',
                    border: '0px'
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'rgba(256, 256, 256, 0.54)'
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    color: 'rgba(255, 255, 255, 0.64)',
                    '&.Mui-checked': {
                        color: 'rgba(255, 255, 255, 0.90)'
                    }
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                dense: {
                    backgroundColor: '#0e0e0e'
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    color: 'white'
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: 'rgba(256, 256, 256, 0.54)'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                icon: {
                    color: 'rgba(256, 256, 256, 0.54)'
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    borderBottom: '2px solid rgb(256,256,256, 0.9)'
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'white'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: 'white'
                },
                head: {
                    color: 'white'
                },
                body: {
                    color: 'white'
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                track: {
                    backgroundColor: 'white'
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-active': {
                        color: 'rgba(256,256,256,0.85) !important'
                    }
                },
                label: {
                    color: 'rgb(256,256,256, 0.4)'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    color: 'rgba(256, 256, 256, 0.87)'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: 'rgba(256, 256, 256, 1)'
                }
            }
        }
    }
});
class LayoutStore extends StoreParaSingleton {
    themeLight = THEME_LIGHT;
    themeDark = THEME_DARK;

    isTemaDark: boolean;

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        makeObservable(this, {
            isTemaDark: observable,
            objetoSave: computed,
            toggleTema: action
        });

        // Expõe o tema atual como atributo no <html> para que os arquivos .css
        // possam ter overrides de dark mode via seletor [data-theme="dark"].
        reaction(
            () => this.isTemaDark,
            (dark) => {
                if (typeof document !== 'undefined') {
                    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
                }
            },
            { fireImmediately: true }
        );
    }

    get objetoSave() {
        return {
            nomeStore: 'LayoutStore',
            isTemaDark: this.isTemaDark
        };
    }


    get theme() {
        return !this.isTemaDark ? this.themeLight : this.themeDark;
    }

    get backgroundProcesso() {
        return !this.isTemaDark ? "#a0a1ef" : "#6060BB"
    }

    get warningColor() {
        return !this.isTemaDark ? red[800] : yellow[800];
    }

    get attentionColor() {
        return !this.isTemaDark ? yellow[600] : yellow[600];
    }

    get backgroundProcessoPadrao() {
        return !this.isTemaDark ? '#FFFFFF' : '#2e2e2e';
    }

    get colorPrimary() {
        return this.theme.palette.primary.main;
    }

    get colorSecondary() {
        return this.theme.palette.secondary.main;
    }

    get backgroundColor() {
        return !this.isTemaDark ? '#FFFFFF' : '#2e2e2e';
    }

    get backgroundColorFiltros() {
        return !this.isTemaDark ? '#093170' : '#2e2e2e'
    }

    get backgroundColor2() {
        return !this.isTemaDark ? '#FFFFFF' : '#000';
    }

    get backgroundColorListDragging() {
        return !this.isTemaDark ? '#73e8ff' : '#0086c3';
    }

    get backgroundColorList() {
        return !this.isTemaDark ? grey[300] : grey[100];
    }


    get colorTextPrimary() {
        return !this.isTemaDark ? 'rgb(1, 87, 155)' : lightBlue[300];
    }

    get colorTextDefault() {
        return !this.isTemaDark ? '#FFF' : '#000';
    }

    get colorSelected() {
        return !this.isTemaDark ? grey[500] : '#4040AB';
    }

    get colorIcon() {
        return !this.isTemaDark ? grey[500] : grey[200];
    }

    get backgroundMenuLateral() {
        return !this.isTemaDark ? 'rgba(0, 0, 0, 0.04)' : '#1f1f1f';
    }

    get colorMenuLateralTexto() {
        return !this.isTemaDark ? 'black' : '#e8e8e8';
    }

    get backgroundMenuLateralHover() {
        return !this.isTemaDark ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.08)';
    }

    get backgroundMenuLateralSelecionado() {
        return !this.isTemaDark ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.14)';
    }

    get colorBorder() {
        return !this.isTemaDark ? 'rgb(13, 71, 161, 0.6) !important' : grey[200] + ' !important';
    }
    get highlightTexto() {
        return !this.isTemaDark ? red[500] : lightBlue[300];
    }
    get corPossuiEtiquetas() {
        return !this.isTemaDark ? orange[700] : yellow[700];
    }
    get corIconDefault() {
        return !this.isTemaDark ? 'black' : 'white';
    }
    get corIconDisableDefault() {
        return !this.isTemaDark ? 'rgb(0,0,0,0.26)' : 'rgb(256,256,256,0.26)';
    }

    toggleTema = () => {
        this.isTemaDark = !this.isTemaDark;
    };
}

export default new LayoutStore();